import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import HealthIcon from '@mui/icons-material/HealthAndSafety';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Map icon string to Material-UI icon component
const iconMap = {
  verified: <VerifiedIcon color="success" />,
  health: <HealthIcon color="primary" />,
  block: <BlockIcon color="error" />,
  check: <CheckCircleIcon color="success" />,
  // fallback for 'eco' or any unknown icon
  eco: <CheckCircleIcon color="success" />,
};

const FeatureChip = ({ icon, text }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      p: 1,
      backgroundColor: 'grey.50',
      borderRadius: 1,
      mb: 1,
    }}
  >
    {iconMap[icon] || <VerifiedIcon />}
    <Typography variant="body2" fontWeight="medium">
      {text}
    </Typography>
  </Box>
);

const Checklist = ({ title, items = [] }) => (
  <Box sx={{ my: 4 }}>
    {title && (
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{ textAlign: 'center', mb: 3 }}
        color="primary"
      >
        {title}
      </Typography>
    )}
    <Grid container spacing={2}>
      {items.map((item, idx) => (
        <Grid item xs={12} sm={6} key={idx}>
          <FeatureChip icon={item.icon} text={item.text} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Checklist; 